export default __webpack_public_path__ + "static/1-fee5b9110a6d69b48bda73ba50cb70ea.webp";